import { call } from "../core";

export const callGetCrossSells = () => {
  return call("/cross-sells", "GET", {});
};
